import { Component, ojs, app } from "modular-openscriptjs";
import { either, empty } from "../helpers";

const h = app("h");

export default class ProfilePic extends Component {
	render(user, ...args) {
		let src = user.profile_photo_path;
		let alt = user.display_name;

		if(empty(src)) {
			src = "/assets/images/user-avatar.png";
		}

		return h.img(
			{
				src: src,
				alt: alt,
				class: "rounded-circle",
				style: "width: 30px; height: 30px; object-fit: cover;",
			},
			...args
		);
	}
}
